import { render, staticRenderFns } from "./SelectedComparisonVehicleCard.vue?vue&type=template&id=0f4e9c66&scoped=true"
import script from "./SelectedComparisonVehicleCard.vue?vue&type=script&lang=ts"
export * from "./SelectedComparisonVehicleCard.vue?vue&type=script&lang=ts"
import style0 from "./SelectedComparisonVehicleCard.vue?vue&type=style&index=0&id=0f4e9c66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4e9c66",
  null
  
)

export default component.exports